<ion-header>
    <ion-toolbar
        color="primary"
        style="padding-left: 1em">
        <div slot="start">{{ title | translate }}</div>
        <ion-button
            (click)="dismissModal()"
            fill="outline"
            slot="end">
            <ion-icon
                name="close"
                style="color: var(--ion-color-primary-contrast)"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>
<ion-content>
    <div>
        <ion-list>
            @for (role of roleSelection; track role.name) {
                @if (role.isVisible) {
                    <ion-item>
                        <ion-checkbox
                            (ionChange)="onItemSelection()"
                            [(ngModel)]="role.isChecked"
                            [disabled]="role.isDisabled"
                            labelPlacement="start"
                            >{{ 'USER.ROLE.' + role.name | translate }}</ion-checkbox
                        >
                    </ion-item>
                }
            }
        </ion-list>
    </div>
    @if (!isLoadingSuccess) {
        <curafida-loading
            (actionButtonClicked)="initRoleList()"
            (timeout$)="isLoading = false; isLoadingSuccess = false"
            [showActionButtonOnTimeout]="true"
            [showSpinner]="isLoading">
        </curafida-loading>
    }
</ion-content>
<ion-footer class="no-border ion-margin-top ion-margin-bottom">
    @if (isLoadingSuccess) {
        <div class="flex-container-row full-width justify-content-space-between ion-padding-end ion-padding-start">
            <ion-button
                (click)="dismissModal()"
                class="btn-font-medium"
                color="danger"
                >{{ 'CANCEL' | translate }}
            </ion-button>
            <ion-button
                (click)="returnSelectedGroups()"
                [disabled]="isButtonDisabled()"
                class="btn-font-medium"
                >{{ 'SELECT_ITEM_CONFIRM' | translate }}
            </ion-button>
        </div>
    }
</ion-footer>
